import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';

/**
 * HometownNews / PolicyInfo 검색 결과 카드 (`SearchContentsCard`)의 스켈레톤.
 */
function SearchContentsCardSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-24 w-3/4 rounded-xxsmall mobile-tablet:h-20" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div role="status" aria-label={"\uCF58\uD150\uCE20 \uCE74\uB4DC \uB85C\uB529 \uC911"} className="flex flex-col gap-8 rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 mobile-tablet:gap-12 mobile-tablet:rounded-none mobile-tablet:border-0"><div className="flex items-start gap-24"><div className="flex min-w-0 flex-1 flex-col gap-8 mobile-tablet:gap-12">{t0}<div className="flex flex-col gap-4"><Skeleton className="h-16 w-full rounded-xxsmall" /><Skeleton className="h-16 w-5/6 rounded-xxsmall" /></div><Skeleton typo="caption1" className="w-60 rounded-xxsmall" /></div><Skeleton className="size-96 shrink-0 rounded-small mobile-tablet:size-68 mobile-tablet:self-center" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
interface SearchContentsCardSkeletonListProps {
  count: number;
}
export function SearchContentsCardSkeletonList(t0) {
  const $ = _c(2);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <ul aria-busy="true" className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100 mobile-tablet:pb-0">{Array.from({
        length: count
      }, _temp)}</ul>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return <li key={index}><SearchContentsCardSkeleton /></li>;
}